import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['allowAbstainCheckbox', 'allowCommentsCheckbox']

  declare allowAbstainCheckboxTarget: HTMLInputElement;
  declare allowCommentsCheckboxTarget: HTMLInputElement;
}
